import React from 'react'
import { updateUserSettings } from '../../lib/api'

import { useEnvironment } from '../EnvironmentProvider'

const EnterModeContext = React.createContext(null)

const KEY = 'enter_to_newline'

const EnterModeProvider = ({ children }) => {
  const { user: currentUser, update: updateUser } = useEnvironment()

  const [sendOnEnter, _setSendOnEnter] = React.useState(true)
  const [temp, setTemp] = React.useState(false)

  // Updates
  React.useEffect(() => {
    if (currentUser) {
      const val = currentUser.settings.find(s => s.key === KEY)
      _setSendOnEnter(val?.value !== 'false')
    }
  }, [currentUser])

  const setSendOnEnter = React.useCallback(
    async val => {
      _setSendOnEnter(val)
      const oldSettings = currentUser.settings.reduce((prev, curr) => {
        prev[curr.key] = curr.value
        return prev
      }, {})
      const newSettings = Object.entries({ ...oldSettings, [KEY]: val }).map(
        ([key, value]) => ({
          key,
          value: String(value)
        })
      )
      try {
        const response = await updateUserSettings(currentUser.id, {
          items: newSettings
        })
        updateUser({ ...currentUser, settings: response })
      } catch (err) {
        console.error('Error changing send setting', err)
      }
    },
    [currentUser, updateUser]
  )

  const enableTemp = React.useCallback(() => {
    setTemp(true)
  }, [])

  const resetTemp = React.useCallback(() => {
    setTemp(false)
  }, [])

  return (
    <EnterModeContext.Provider
      value={{ sendOnEnter, setSendOnEnter, temp, enableTemp, resetTemp }}
    >
      {children}
    </EnterModeContext.Provider>
  )
}

export default EnterModeProvider

export const useEnterMode = () => React.useContext(EnterModeContext)
